import { OperationalTeamDriver } from './operational-team-driver.model';

export class OperationalTeamModel {
  standardDriver!: OperationalTeamDriver;
  nightDriver!: OperationalTeamDriver;
}
